"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'style.form.title.edit': 'Modifica Stile di Scrittura',
    'style.form.title.add': 'Aggiungi Stile di Scrittura',
    'style.form.back': 'Indietro',
    'style.form.name.label': 'Nome',
    'style.form.name.placeholder': 'Nome dello stile',
    'style.form.description.label': 'Descrizione',
    'style.form.description.placeholder': 'Descrivi questo stile di scrittura',
    'style.form.prompt.label': 'Prompt dello Stile',
    'style.form.prompt.placeholder': 'Inserisci il prompt IA che definisce questo stile di scrittura...',
    'style.form.common.label': 'Stile Comune',
    'style.form.common.description': 'Gli stili comuni sono disponibili per tutti gli utenti ma possono essere modificati solo dai super amministratori',
    'style.form.active.label': 'Attivo',
};
